
import { DiagramEditor } from "@/components/diagrams/DiagramEditor";

export default function DiagramEditorPage() {
  return (
    <div className="h-screen w-full overflow-hidden">
      <DiagramEditor />
    </div>
  );
}
